// Other platforms and older native shells have no Sparkle update action.
export default function MacUpdateButton() { return null; }
